import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import rightArrow from "./right-arrow.svg";
import closeIcon from "./close.svg";
import GreensImg from "./greens.png";
const PromoCard = () => {
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        setShowModal(true);
    }, []);
    return showModal ? (_jsxs("div", { className: styles.modalContainer, children: [_jsx("button", { className: styles.cancelButton, onClick: () => {
                    setShowModal(false);
                }, children: _jsx("img", { src: closeIcon, className: styles.closeIcon }) }), _jsx("a", { href: "/app/subscription#greens", className: styles.invisibleLink, children: _jsxs("div", { className: styles.linkContainer, children: [_jsxs("div", { className: styles.copy, children: [_jsx("div", { className: styles.newFlavorBadge, children: "Just Launched" }), _jsxs("div", { className: styles.hed, children: ["Daily ", _jsx("br", {}), _jsx("span", { className: styles.transparentText, children: "Performance" }), _jsx("br", {}), " Greens ", _jsx("img", { src: rightArrow })] })] }), _jsx("div", { className: styles.image, children: _jsx("img", { src: GreensImg, alt: "A packet of Daily Performance Greens powder" }) })] }) })] })) : null;
};
export default PromoCard;
